import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpxa6q27s7: FaireProductEntity = {
  token: "p_cpxa6q27s7",
  type: "product",
  name: "Guidance from Gaia Oracle by Shannon Kaiser",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/a3798281b56112f7989f867ecc1eb887c7010a691ac5986443f36705d3037de4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2bb4cc460d8f0c5a68414e807bd3107e153211a76ca743b212d7ab6aa29ad21.jpeg",
    "https://cdn.faire.com/fastly/7b7442beded74fc03a6f573e49a5f0dca48c8856d2a5f7b78103f1453cb7d975.jpeg",
    "https://cdn.faire.com/fastly/58da57f7df37d4b7d39c21576177fc4796ba380b39cd4d2ba5fb11ecd9f01a0d.jpeg",
    "https://cdn.faire.com/fastly/19ebe4a976a590bd4f1e2a7dec6742eb9d8820b889bbb8d0e13f1ef976e0953e.jpeg",
    "https://cdn.faire.com/fastly/460865959c7069e3ad2b01b09cde566487254bf39d64b737b9725dd6b40e492e.jpeg",
  ],
  priceDollars: 16.63,
  description:
    "[Beyond Words Dist]\r\n\r\nWINNER OF THE 2025 SILVER COVR VISIONARY AWARD IN INSPIRATIONAL CARD DECKS\r\n \r\nGaia’s ancient wisdom is all around us, gently delivering her messages through the animal kingdom. Commune with Mother Earth and receive support from your animal spirit guides with this ornate 52-card oracle deck and 176-page, full-color guidebook from bestselling author and award-winning graphic design artist Shannon Kaiser.\r\n\r\nGaia symbolizes all life on Earth as well as the planet itself. Our ancestors understood the harmonizing effects of connecting with nature and Earth daily, and now—at a time when people are yearning to escape the hustle and chaos of society and technology—practical tools like Guidance from Gaia Oracle can usher in the peace we all deeply need. This powerful deck combines the ancient wisdom and lush imagery of the benevolent animal spirit guides of Mother Earth with powerful insights to guide you to rebalance and calm your life from the inside out.\r\n \r\n Categori",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:17.850Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
